// 미니멀 스켈레톤 로딩 컴포넌트 — shimmer 애니메이션은 styles.css의 .skeleton 클래스에서.
// 사용: <SkeletonTable rows={6} cols={5} />, <SkeletonStats count={4} />, <Skeleton width="60%" />

import { CSSProperties } from 'react';

type Variant = 'line' | 'box' | 'circle' | 'pill';

export function Skeleton({
  variant = 'line',
  width,
  height,
  className,
  style,
}: {
  variant?: Variant;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}) {
  const base: CSSProperties = {
    width: width ?? (variant === 'circle' ? 36 : variant === 'pill' ? 64 : '100%'),
    height: height ?? (variant === 'line' ? 14 : variant === 'pill' ? 22 : variant === 'circle' ? 36 : 60),
    borderRadius: variant === 'circle' ? '50%' : variant === 'pill' ? 999 : 6,
    ...style,
  };
  return <span className={`skeleton ${className ?? ''}`} style={base} aria-hidden="true" />;
}

export function SkeletonTable({
  rows = 6,
  cols = 5,
  showHeader = false,
}: {
  rows?: number;
  cols?: number;
  showHeader?: boolean;
}) {
  return (
    <div className="skeleton-table" aria-busy="true" aria-label="로딩 중">
      {showHeader && (
        <div className="skeleton-row skeleton-row-head">
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={`h${i}`} height={10} width={i === 0 ? 56 : (i === 1 ? 120 : 80)} />
          ))}
        </div>
      )}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="skeleton-row">
          {Array.from({ length: cols }).map((_, c) => {
            const w = c === 0 ? 84 : c === 1 ? '36%' : c === cols - 1 ? 64 : '20%';
            return <Skeleton key={`${r}-${c}`} height={14} width={w} />;
          })}
        </div>
      ))}
    </div>
  );
}

export function SkeletonStats({ count = 4 }: { count?: number }) {
  return (
    <div className="summary" aria-busy="true" aria-label="로딩 중">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="stat skeleton-stat">
          <Skeleton width={86} height={10} />
          <Skeleton width="58%" height={22} style={{ marginTop: 8 }} />
          <Skeleton width="40%" height={10} style={{ marginTop: 6 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className="card skeleton-card" aria-busy="true" aria-label="로딩 중">
      <Skeleton width={120} height={12} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={14} style={{ marginTop: 12, width: i === lines - 1 ? '40%' : '80%' }} />
      ))}
    </div>
  );
}
